

function remove_Bundles(item_key, extra_item, quantity)
  {

 

      if(quantity>0)
      {

        quantity--;
      }

  
if(quantity<0)

{

    quantity=0; 
}
let updates =  "{" + '"' + "updates" + '"' +":{" + '"' + item_key + '"'+ ":0, " + '"' + extra_item + '"'  + ":" + quantity+ " }}";
    
  
                
    $.ajax({
          
  type: "POST",
  url: "/cart/update.js",
      headers:{
        'Content-Type': 'application/json'
      },
  data: updates,
      async:false
  ,


  success: () => {

    alert('succecss');

    
  },
  error: function(xhr, status, error) {


          console.log(xhr);
    console.log('done ' + extra_item + "-" + quantity + "-" + item_key);
  },
  dataType: "json"
  });


  } 

  function remove_items3(item_key, extra_item, quantity)

  {





   let formData = {

       id:item_key,
     quantity:0
   }







                         if(quantity > 0)
            {
             quantity--;
            }


      if(quantity < 0)
      {
          quantity = 0;
      }


            
               let formData2 = {

       id:extra_item,
     quantity:quantity
   }

  
            ;
    $.ajax({
            
  type: "POST",
  url: "/cart/change.json",

   headers:{
        'Content-Type': 'application/json'
      },
  data: JSON.stringify(formData),

  success: () => {



    
  },
  error: function(xhr, status, error) {

          console.log(xhr);
    console.log('done ' + extra_item + "-" + quantity + "-" + item_key);

     
           
  },
  dataType: "text",
      async:false
  });
    



    
  }
    
  function remove_items(item_key, extra_item, quantity)
          {

  






remove_items3(item_key, extra_item, quantity);



remove_items2(item_key, extra_item, quantity);


location.reload();



     

            }
  




  function remove_items2(item_key, extra_item, quantity)
    {


      

             if(quantity > 0)
            {
             quantity--;
            }


      if(quantity < 0)
      {
          quantity = 0;
      }


         let formData = {
quantity:quantity,
       id:extra_item
     
   }       

      



                $.ajax({
                  
 
  type: "POST",
  url: "/cart/change.json",
                  headers:{
        'Content-Type': 'application/json'
      },
  data: JSON.stringify(formData),


  success: () => {
    

    
  },
  error: function(xhr, status, error) {


          console.log(xhr);

  },
  dataType: "text",
                  async:false
  });
           
              

      
    }